import { Component, inject } from '@angular/core';
import { COMPONENT_VERSIONS } from '@fgb/core';
import { CartCheckoutPageV1Component } from './cart-checkout-page-v1/cart-checkout-page-v1.component';
import { UnifiedCheckoutPageComponent } from '../unified-checkout-page/unified-checkout-page.component';

// Version 2 is the unified checkout: the old v2 cart checkout page it used to
// point at has been removed, and the unified checkout replaces it.
const componentMap = {
  1: CartCheckoutPageV1Component,
  2: UnifiedCheckoutPageComponent,
};

type MarketplaceComponentVersion = keyof typeof componentMap;

@Component({
  selector: 'fgb-cart-checkout-page',
  template: `<ng-container *ngComponentOutlet="component"></ng-container>`,
})
export class CartCheckoutPageComponent {
  private readonly marketplaceVersion = inject(COMPONENT_VERSIONS)?.marketplace as MarketplaceComponentVersion;

  get component() {
    return componentMap[this.marketplaceVersion || 1]; // default to version 1 if not specified
  }
}
